const parseFlag = (value, defaultValue) => {
  if (value == null || value === '') return defaultValue;
  return ['1', 'true', 'yes', 'on'].includes(String(value).toLowerCase());
};

const apiBaseUrl = String(import.meta.env.VITE_API_BASE_URL || '').toLowerCase();
const isDevelopmentDeployment = apiBaseUrl.includes('dev.api.lab.mdg-meidai.com')
  || apiBaseUrl.includes('127.0.0.1')
  || apiBaseUrl.includes('localhost');

export const featureFlags = {
  prediction: isDevelopmentDeployment || parseFlag(import.meta.env.VITE_FEATURE_PREDICTION, true),
  aiCorner: isDevelopmentDeployment || parseFlag(import.meta.env.VITE_FEATURE_AI_CORNER, true),
  english: isDevelopmentDeployment || parseFlag(import.meta.env.VITE_FEATURE_ENGLISH, true),
  tvDemo: isDevelopmentDeployment || parseFlag(import.meta.env.VITE_FEATURE_TV_DEMO, true),
  admin: isDevelopmentDeployment || parseFlag(import.meta.env.VITE_FEATURE_ADMIN, true),
  meidaisai: isDevelopmentDeployment || parseFlag(import.meta.env.VITE_FEATURE_MEIDAISAI, true),
};

